import { BaseWebComponentController } from '../../../../../framework/BaseWebComponentController';
import { IntegrityMonitorRegistryKeyRuleFormWebComponent } from '../component/IntegrityMonitorRegistryKeyRuleFormWebComponent';
import { IntegrityMonitorRegsitryKeyRuleFormView } from '../view/IntegrityMonitorRegsitryKeyRuleFormView';
import { template } from '../view/template';
import { GzFormFieldWebComponent } from '../../../../../ui/gzForm/formField';

export class IntegrityMonitorRegistryKeyRuleFormController extends BaseWebComponentController {
  public view!: IntegrityMonitorRegsitryKeyRuleFormView;

  constructor(component: IntegrityMonitorRegistryKeyRuleFormWebComponent) {
    super(component);

    this.initialSetup({
      viewConstructor: IntegrityMonitorRegsitryKeyRuleFormView,
      viewTemplate: template,
    });
  }

  public resetFields() {
    // discard changes and skip validation
    this.view.formGroup.applyToFormGroupFields(field => {
      if (field instanceof GzFormFieldWebComponent) {
        field.discardChanges();
        field.resetField();
      }
    });
  }
}
